import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    q: '¿Mi hijo va a explotar si le apago la pantalla?',
    a: "Es probable que haya resistencia inicial, pero el protocolo incluye la técnica de 'Aviso 5-2-1' y respiración conjunta que reduce la intensidad de la reacción en un 60% desde el primer día. Te enseñamos a gestionar esa explosión sin ceder."
  }, {
    q: '¿Qué hago si mi pareja no coopera?',
    a: "El método incluye un 'Contrato Familiar' donde los adultos también firman compromisos. Cuando las reglas son para todos (no solo para el niño), la autoridad moral aumenta y la pareja suele sumarse al ver los resultados iniciales."
  }, {
    q: '¿Las apps educativas cuentan como tiempo de pantalla?',
    a: 'Para el cerebro de un niño, la dopamina es dopamina, venga de un juego de matemáticas o de un video de YouTube. El método te enseña a diferenciar calidad, pero el límite de tiempo total debe respetarse igual para evitar la sobreestimulación.'
  }, {
    q: '¿Para qué edades sirve este método?',
    a: 'El libro cubre estrategias específicas escaladas para niños de 3 a 13 años. Lo que funciona con un preescolar (distracción) no funciona con un preadolescente (negociación y consecuencias lógicas). Cubrimos todo el espectro.'
  }, {
    q: '¿Y si después de 30 días no veo cambios?',
    a: 'Si aplicas el método consistentemente y la ansiedad o agresividad persiste al mismo nivel tras un mes, el libro te indica cuándo es momento de buscar ayuda profesional presencial. Pero el 90% de las familias ven cambios drásticos en la primera semana.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-31">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-32">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-center text-slate-900 mb-12" data-id="element-33">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-34">
          {faqs.map((faq, i) => <FAQItem key={i} question={faq.q} answer={faq.a} data-id="element-35" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-slate-200 rounded-lg bg-white overflow-hidden" data-id="element-36">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-5 text-left hover:bg-slate-50 transition-colors" data-id="element-37">
        <span className="font-bold text-slate-900 pr-8" data-id="element-38">{question}</span>
        {isOpen ? <Minus className="w-5 h-5 text-brand-primary flex-shrink-0" data-id="element-39" /> : <Plus className="w-5 h-5 text-slate-400 flex-shrink-0" data-id="element-40" />}
      </button>
      <AnimatePresence data-id="element-41">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-42">
            <div className="p-5 pt-0 text-slate-600 leading-relaxed border-t border-slate-100" data-id="element-43">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}